import apiClient from "../apiClient";
const urlPath = "/api/matches/";


/**
 * Erstelle ein neues Match.
 * @param {Object} match Das Match-Objekt, das erstellt werden soll.
 * @returns {Promise<Object>} Das erstellte Match.
 */
export const createMatch = async (match) => {
  const response = await apiClient.post(urlPath, match);
  return response.data; // Erwartet das erstellte Match
};

/**
 * Aktualisiere ein bestehendes Match.
 * @param {number} matchId Die ID des Matches.
 * @param {Object} match Die aktualisierten Match-Daten.
 * @returns {Promise<Object>} Das aktualisierte Match.
 */
export const updateMatch = async (matchId, match) => {
  const response = await apiClient.put(`${urlPath}${matchId}/`, match);
  return response.data; // Erwartet das aktualisierte Match
};

/**
 * Lösche ein Match.
 * @param {number} matchId Die ID des Matches.
 * @returns {Promise<void>} Keine Rückgabe.
 */
export const deleteMatch = async (matchId) => {
  await apiClient.delete(`${urlPath}${matchId}/`);
};

/**
 * Issue #29: Beende ein Open-End Match manuell.
 * @param {number} matchId Die ID des Matches.
 * @param {number|null} winnerId Die ID des Gewinner-Spielers (optional, auto-detect wenn nicht angegeben).
 * @returns {Promise<Object>} Das beendete Match.
 */
export const finishMatch = async (matchId, winnerId = null) => {
  const payload = winnerId ? { winner: winnerId } : {};
  const response = await apiClient.patch(`${urlPath}${matchId}/finish/`, payload);
  return response.data;
};